import { z } from "zod";
import { COURSE_CONTENT_BLOCK_TYPES } from "@/modules/learningCenter/features/CourseManagement/types/course";

export const courseContentBlockSchema = z.object({
  /** Client-side id for list keying; the server uuid when editing. */
  id: z.string(),
  uuid: z.string().nullable().optional(),
  type: z.enum(COURSE_CONTENT_BLOCK_TYPES),
  content: z.string().nullable().optional(),
  metadata: z.record(z.unknown()).nullable().optional(),
});

export const courseModuleSchema = z.object({
  id: z.string(),
  uuid: z.string().nullable().optional(),
  title: z.string().min(1, "A module title is required"),
  description: z.string().nullable().optional(),
  difficulty: z.string().nullable().optional(),
  estimatedMinutes: z.number().nullable().optional(),
  tags: z.array(z.string()),
  blocks: z.array(courseContentBlockSchema),
  /**
   * Set on a module added from the published library. The server copies the
   * referenced module's content into the course as an independent snapshot.
   */
  sourceLibraryModuleUuid: z.string().nullable().optional(),
});

export const courseFormSchema = z.object({
  title: z.string().min(1, "A course title is required"),
  tagline: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  level: z.string().nullable().optional(),
  estimatedHours: z.string().nullable().optional(),
  targetAudience: z.string().nullable().optional(),
  learningObjectives: z.array(z.string()),
  courseOverview: z.string().nullable().optional(),
  thumbnailFileUuid: z.string().nullable().optional(),
  heroBannerFileUuid: z.string().nullable().optional(),
  tradeIds: z.array(z.string()),
  /**
   * Modules are managed only on the Edit screen and may be empty (a freshly
   * created course has none). Publishing — which requires at least one module —
   * is gated server-side, not by this schema.
   */
  modules: z.array(courseModuleSchema),
});

export type CourseFormData = z.infer<typeof courseFormSchema>;
export type CourseFormModule = z.infer<typeof courseModuleSchema>;
export type CourseFormBlock = z.infer<typeof courseContentBlockSchema>;
